import { $, $$ } from "../js/utils.js";

export default class Action {
  constructor() {
    this.init();
  }
  init() {
    // this.headerScroll = new HeaderScroll('header', 100, 'scroll-head');
    // this.faqAccordion = new FAQAccordion('.page-faq-list');
    // this.mobileMenu = new MobileMenu({
    //   menuIconSelector: '.icon-menu',
    //   menuSelector: '.mobile-menu',
    //   iconActiveClass: 'icon-cross',
    //   menuActiveClass: 'active',
    //   closeOnClickOutside: true
    // });
    this.goTop = new ScrollToTop(".go-top")
  }

  destroy() {
    this.headerScroll?.destroy();
    this.faqAccordion?.destroy();
    this.mobileMenu?.destroy();
  }
  
}
export class ScrollToTop {
  constructor(selector = ".go_top", threshold = 400) {
    this.button = document.querySelector(selector);
    this.threshold = threshold;

    if (!this.button) return;

    this.init();
  }

  init() {
    this.button.addEventListener("click", this.scrollToTop.bind(this));
    window.addEventListener("scroll", this.toggleVisibility.bind(this));
    this.toggleVisibility();
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  toggleVisibility() {
    const flag = window.scrollY > this.threshold ? true : false;
    flag ? this.button.classList.add('animate__fadeInUp') : this.button.classList.remove('animate__fadeInUp')
    this.button.style.pointerEvents = flag ? "none" : "auto";
  }
}